import arraymove from "array-move";

export default function dealsHubAdmin(state = [], action) {
  switch (action.type) {
    case "ADD_CATEGORY":
      return [...state, action.payload];

    case "ADD_BANNER":
      return [...state, action.payload];

    case "DELETE_BANNER":
      return state.filter(e => e.uuid !== action.payload);

    case "PUBLISH_BANNER":
      for (let index in state) {
        if (state[index].uuid === action.payload.bannerUuid) {
          state[index].is_published = true;
        }
      }
      return state;

    case "UNPUBLISH_PROMO" :
      for(let index in state) {
        if (state[index].uuid === action.payload.bannerUuid) {
          //search in promotion list
          for(let i in state[index].promo_list) {
            if(state[index].promo_list[i]=== action.payload.promoUuid) {
              state[index].promo_list[i].is_published = false
            }
          }
        }
      }

    case "PUBLISH_PROMO" :
      for(let index in state) {
        if (state[index].uuid === action.payload.bannerUuid) {
          //search in promotion list
          for(let i in state[index].promo_list) {
            if(state[index].promo_list[i]=== action.payload.promoUuid) {
              state[index].promo_list[i].is_published = true
            }
          }
        }
      }

    case "UNPUBLISH_BANNER":
      for (let index in state) {
        if (state[index].uuid === action.payload.bannerUuid) {
          state[index].is_published = false;
        }
      }
      return state;

    case "FETCH_DEALS_HUB_DATA":
      let temp = [];
      if (action.payload) {
        for (let index = 0; index < action.payload.length; ++index) {
          temp = [...temp, action.payload[index]];
        }
      }
      return temp;

    case "HANDLE_UPDATE":
      const { uuid, value } = action.payload;
      for (let i in state) {
        if (state[i].uuid === uuid) {
          state[i].name = value;
          break;
        }
      }
      return state;

    case "HANDLE_PROMO_CHANGE":
      const { bannerIndex, unitBannerIndex, promoDetails } = action.payload;
      state[bannerIndex]["bannerImages"][unitBannerIndex]["is_promotional"] = promoDetails.is_promotional;
      state[bannerIndex]["bannerImages"][unitBannerIndex]["start_time"] = promoDetails.promotion["start_time"];
      state[bannerIndex]["bannerImages"][unitBannerIndex]["end_time"] = promoDetails.promotion["end_time"];
      state[bannerIndex]["bannerImages"][unitBannerIndex]["promotion_tag"] = promoDetails.promotion["promotion_tag"];
      return state;

    case "HANDLE_PROMO_SECTION_PRICE_CHANGE":
      state[action.payload.sectionIndex]
      ["products"][action.payload.sectionProductIndex]
      ["promotional_price"] = action.payload.promoPrice;
      return state;

    case "HANDLE_PROMO_BANNER_PRICE_CHANGE":
      state[action.payload.bannerIndex]
      ["bannerImages"][action.payload.unitBannerIndex]
      ["products"][action.payload.productIndex]
      ["promotional_price"] = action.payload.promoPrice;
      return state;

    case "HANDLE_DELETE":
      state = action.payload;
      return state;

    case "REORDER_LIST":
      for(let index in state){
        if(state[index].order_index === action.payload.oldIndex + 1){
          state[index].order_index = action.payload.newIndex + 1;
        }else if (state[index].order_index === action.payload.newIndex + 1){
          state[index].order_index = action.payload.oldIndex + 1;
        }
      }
      return arraymove(
        state,
        action.payload.oldIndex,
        action.payload.newIndex
      );

    case "HANDLE_BANNER_PROMO_ADDITION":
      for (let i in state) {
        if (state[i].uuid === action.payload.section_uuid) {
          state[i].promo_list = [...state[i].promo_list, action.payload];
          break;
        }
      }

      return state;

    case "HANDLE_BANNER_PROMO_UPDATION":
      for (let outerIndex in state) {
        if (state[outerIndex].uuid === action.payload.section_uuid) {
          for (let innerIndex in state[outerIndex].promo_list) {
            if (
              state[outerIndex].promo_list[innerIndex].uuid ==
              action.payload.promoObj.uuid
            ) {
              if ("isPublishToggled" in action.payload) {
                state[outerIndex].promo_list[innerIndex].is_published = action.payload.isPublishToggled;
              } else {
                state[outerIndex].promo_list[innerIndex] = action.payload.promoObj;
              }
              break;
            }
          }
          break;
        }
      }
      return state;

    case "HANDLE_BANNER_PROMO_DELETE":
      state = action.payload;
      return state;

    default:
      return state;
  }
}
